function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * IDP Credit Card From
 * 
 */
import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { COSTS } from '../../../data/Data';
import CardHolder from './fields/CardHolder';
import CreditCard from './fields/CreditCard';
import CVV from './fields/CVV';
import Expiry from './fields/Expiry';
//$FlowFixMe

import './CreditCardForm.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class CreditCardForm extends Component {
  constructor(props) {
    super(props);
    /**
     * Check if our user fields are valid
     */
    _defineProperty(this, "isValid", () => {
      const {
        creditCard,
        transaction
      } = this.props;
      const {
        gateway_url,
        token
      } = transaction;
      let fieldsValid = true;
      let gatewayValid = gateway_url && token ? true : false;
      for (let field in creditCard) {
        if (!creditCard[field].valid) {
          fieldsValid = false;
          break;
        }
      }
      return fieldsValid && gatewayValid;
    });
    /**
     * submit the form
     */
    _defineProperty(this, "submit", e => {
      e.preventDefault();
      const {
        formRef
      } = this.props;
      const valid = this.isValid();
      const {
        submit
      } = this.state;
      if (!valid || submit || !formRef || !formRef.current) {
        return null;
      }
      this.setState({
        submit: true,
        spinner: true
      }, () => this.formAction());
    });
    /**
     * Form Action
     */
    _defineProperty(this, "formAction", () => {
      this.props.formRef.current.submit();
    });
    /**
     * Error
     */
    _defineProperty(this, "error", err => {
      const {
        bugsnagClient,
        jest
      } = this.props;
      if (jest) return null;
      console.warn(err);
      bugsnagClient.notify(err);
    });
    /**
     * reload the page
     */
    _defineProperty(this, "reset", () => {
      window.location.reload();
    });
    this.state = {
      apiSuccess: false,
      fatZebraVars: {
        amount: '0.00',
        reference: '',
        currency: 'AUD'
      },
      fatZebraResult: {},
      fatZebraErrorMessage: '',
      paymentError: false,
      spinner: false,
      submit: false
    };
  }
  /**
   * Hidden fields are gateway dependent
   */
  renderHiddenFields() {
    const {
      application,
      gateway,
      transaction,
      postage
    } = this.props;
    const {
      id,
      created_at
    } = application;
    const {
      name,
      redirectUrl
    } = gateway;
    const {
      token,
      merchant_id,
      timestamp
    } = transaction;
    const price = postage.cost + COSTS.permit;
    const currency = 'AUD';
    const reference = `${id}-${created_at}`;
    switch (name) {
      // https://www.windcave.com/developer-ecommerce-pxpost-pxfusion
      case 'windcave':
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("input", {
            name: "amount",
            type: "hidden",
            value: price
          }), /*#__PURE__*/_jsx("input", {
            name: "currency",
            type: "hidden",
            value: currency
          }), /*#__PURE__*/_jsx("input", {
            name: "returnUrl",
            type: "hidden",
            value: redirectUrl
          }), /*#__PURE__*/_jsx("input", {
            name: "txnRef",
            type: "hidden",
            value: reference
          }), /*#__PURE__*/_jsx("input", {
            name: "txnType",
            type: "hidden",
            value: "Purchase"
          }), /*#__PURE__*/_jsx("input", {
            name: "SessionId",
            type: "hidden",
            value: token ? token : ''
          })]
        });
      case 'nab-securepay':
        // https://auspost.com.au/payments/docs/securepay/resources/Direct_Post_Integration_Guide_1.7.pdf
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("input", {
            name: "EPS_AMOUNT",
            type: "hidden",
            value: parseFloat(price).toFixed(2)
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_MERCHANT",
            type: "hidden",
            value: merchant_id ? merchant_id : ''
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_RESULTURL",
            type: "hidden",
            value: redirectUrl
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_REFERENCEID",
            type: "hidden",
            value: reference
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_TIMESTAMP",
            type: "hidden",
            value: timestamp ? timestamp : ''
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_TXNTYPE",
            type: "hidden",
            value: "0"
          }), /*#__PURE__*/_jsx("input", {
            name: "EPS_FINGERPRINT",
            type: "hidden",
            value: token ? token : ''
          }), /*#__PURE__*/_jsx("input", {
            type: "hidden",
            name: "EPS_REDIRECT",
            value: "TRUE"
          })]
        });
      default:
        // FatZebra direct post doesn't need any hidden fields, as we construct the direct post URL
        return null;
    }
  }
  render() {
    const {
      formRef,
      gateway,
      transaction
    } = this.props;
    const {
      paymentError,
      spinner,
      submit
    } = this.state;
    const {
      gateway_url
    } = transaction;
    const valid = this.isValid();
    switch (true) {
      case paymentError:
        {
          return /*#__PURE__*/_jsxs("div", {
            className: "CreditCardForm error",
            children: [/*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: "triangle-exclamation",
                className: "left"
              }), "There has been an error processing your payment."]
            }), /*#__PURE__*/_jsx("div", {
              className: "button",
              role: "button",
              tabIndex: "0",
              onClick: this.reset,
              children: "Try payment again"
            })]
          });
        }
      default:
        return /*#__PURE__*/_jsxs("form", {
          ref: formRef,
          className: "CreditCardForm",
          action: gateway_url,
          onSubmit: this.submit,
          children: [/*#__PURE__*/_jsx(CardHolder, {
            gateway: gateway
          }), /*#__PURE__*/_jsx(CreditCard, {
            gateway: gateway,
            submit: submit
          }), /*#__PURE__*/_jsx(Expiry, {
            gateway: gateway
          }), /*#__PURE__*/_jsx(CVV, {
            gateway: gateway
          }), this.renderHiddenFields(), /*#__PURE__*/_jsxs("div", {
            className: "footer actions",
            children: [/*#__PURE__*/_jsxs(Link, {
              className: "button cancel reverse",
              to: "/summary",
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: "xmark"
              }), "Cancel Payment"]
            }), /*#__PURE__*/_jsxs("button", {
              className: `button process${valid ? '' : ' disabled'}`,
              disabled: !valid,
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: spinner ? 'spinner' : 'check'
              }), "Process Order"]
            })]
          })]
        });
    }
  }
}
_defineProperty(CreditCardForm, "defaultProps", {
  application: {
    club: {
      abbreviation: 'RAA'
    }
  },
  gateway: {
    name: 'windcave'
  },
  postage: {
    description: 'Express Post within Australia',
    cost: 11.4,
    value: 'express_post'
  },
  transaction: {
    merchant_id: '',
    timestamp: '',
    token: ''
  }
});
const mapStateToProps = ({
  application,
  creditCard,
  transaction,
  postage
}) => {
  return {
    application,
    creditCard,
    transaction,
    postage
  };
};
const VisibleCreditCardForm = connect(mapStateToProps)(CreditCardForm);
export default VisibleCreditCardForm;